import { serviceLocator } from '@/utils/providers/serviceLocator'
import { AuthenticationRepository } from '../repositories/AuthenticationRepository'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'

export async function logoutCase() {
  const newRepository = serviceLocator.getService<AuthenticationRepository>('AuthenticationService')

  const { data } = await useQuery({
    fetcher: async () => await newRepository?.logout(),
    key: 'userToken',
    filterData: JSON.stringify(''),
    skipCaching: true
  })
  if (data.value?.error) return
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  window.location.href = `${import.meta.env.VITE_MAIN_URL}?removePanel=Market`
}
